import { UserTypes } from "enum/UserTypes";

const PLATFORM_LABELS: Record<string, string> = {
  shopify: "Shopify",
  woocommerce: "WooCommerce",
  square: "Square",
  lightspeed: "Lightspeed",
};

export function customerTypeLabel(role?: string, platforms?: string[]): string {
  const type = role === UserTypes.BUSINESS_CUSTOMER ? "Business" : "Personal/Individual";
  const names = (platforms || [])
    .map((platform) => PLATFORM_LABELS[String(platform || "").trim().toLowerCase()])
    .filter(Boolean);
  if (!names.length) {
    return type;
  }
  return `${type} / ${names.join(", ")}`;
}
